import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import { LoginLayout } from 'components';

export const LoginServices = ({ t }) => (
  <LoginLayout title={t('login.title')} description={t('login.description')}>
    <div>
      <a
        className="button button--facebook button--full button--margin-bottom"
        href="/"
      >
        Login with Facebook
      </a>
      <br />
      <a
        className="button button--full button--google button--margin-bottom"
        href="/"
      >
        Login with Google
      </a>

      <Link to="/login-email">{t('login.email.title')}</Link>
    </div>
  </LoginLayout>
);

LoginServices.propTypes = {
  t: PropTypes.func.isRequired
};

export default translate()(LoginServices);



// WEBPACK FOOTER //
// ./src/components/LoginServices/LoginServices.js